/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ApiConfigData,
  handleRedirectWithLoading,
  ModalOrSso,
  NavConfigureData,
  SectionMasterData,
  SectionContentMasterData,
  trackEvent,
  ClientPlatformCode, 
  UserIdAndStatusData, 
  DefaultCardName 
} from "../../Utility/Utility";
import contactus from "../../Assets/imgNewUI/Contact Us.png";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader";

const SideNavbar = ({ setShowModal, setIsLoading, Loading }) => {
  const login = sessionStorage.getItem("login");
  const translation = getTranslation();
  const { navConfigureData } = NavConfigureData(translation?.homePageHeader);
  const apiConfigData = ApiConfigData();
  const integrationId = apiConfigData?.find(
    (data) => data?.paramsKey === "integrationId"
  )?.paramsValue;
  const loginUrl = `${process.env.REACT_APP_INTEGRATION_LOGIN_URL}Login/${integrationId}`;
  const isModal = ModalOrSso();
  const navigate = useNavigate();
  const backBtnRef = useRef();
  const { clientCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();

  const headerClickGAEventTracker = (tab) => {
    trackEvent("navigation_interaction", {
      cta_text: tab?.text,
      destination_url: tab?.cta,
      page_type: tab?.cta?.split("/")?.[1] || "home_page",
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });
  }

  const handleLogin = (e, data) => {
    e.preventDefault();
    headerClickGAEventTracker(data);
    if(!data?.loginRequired && !data?.cta) return;
    if(!data?.loginRequired){
      if (!/^https?:\/\//.test(data?.cta)) {
        navigate(data?.cta);
      } else {
        setIsLoading(true);
        window.open(data?.cta, "_self");
        setTimeout(() => setIsLoading(false), 10000);
      }
    }
    if (data?.isLogin && !login && isModal) {
      navigate("/");
      setShowModal(true);
    } else if (data?.isLogin && !login && !isModal) {
      handleRedirectWithLoading(
        setIsLoading,
        data.cta,
        login,
        setShowModal,
        isModal,
        navigate,
        loginUrl
      );
    } else {
      if (!/^https?:\/\//.test(data?.cta)) {
        navigate(data?.cta);
      } else {
        if (data.cta) {
          handleRedirectWithLoading(
            setIsLoading,
            data.cta,
            login,
            setShowModal,
            isModal,
            loginUrl
          );
        }
      }
    }
  };

  // const handleLogin = (e, data) => {
  //   e.preventDefault();
  //   if (data?.isLogin && !login) {
  //     handleRedirectWithLoading(
  //       setIsLoading,
  //       data.cta,
  //       login,
  //       setShowModal,
  //       isModal,
  //       navigate,
  //       loginUrl
  //     );
  //   } else {
  //     if (!/^https?:\/\//.test(data?.cta)) {
  //       navigate(data?.cta);
  //     } else {
  //       if (data.cta) {
  //         handleRedirectWithLoading(
  //           setIsLoading,
  //           data.cta,
  //           login,
  //           setShowModal,
  //           isModal,
  //           navigate,
  //           loginUrl
  //         );
  //       }
  //     }
  //   }
  // };
  return (
    <>
      <div
        id="top_offer_main_wrapper_container"
        className=" top_offer_main_wrapper_container"
      >
        <CustomBackHeader
          isSticky={true}
          isTransperent={false}
          customClass="offer_title mobile_heading sticky top-0 z-10 bg-white"
        />
        <div className="side-navbar-grid-wrap">
          <div className="side-navbar-grid">
          {navConfigureData?.map((navData, index) => (
            <div className="side-navbar-grid-item" key={index}>
              <Link onClick={(e) => handleLogin(e, navData)}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${navData?.mobImage}`}
                  alt={navData?.text}
                  title={navData?.text}
                  data-url={navData?.cta}
                  className="side-navbar-grid-image cursor-pointer"
                />
              </Link>
            </div>
          ))}
          </div>
        </div>

          {/* <div className="mt-6 px-4">
            <div className="box-wth rounded-2xl border border-gray-300 bg-white">
              <Link
                to="/contact-us"
                className="flex items-center justify-between px-4 py-3 box-h hover:bg-gray-100"
              >
                <div className="flex items-center space-x-3">
                  <img
                    src={contactus}
                    alt="contact-us"
                    className="contact-us"
                  />
                  <span className="cont-sz">{translation?.contactUs}</span>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-5 h-5 text-black cont-sz"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </Link>
            </div>
          </div> */}
      </div>
    </>
  );
};

export default SideNavbar;
